<template>
	<div class="productlist-sortview productlist-top__block">
		<div class="productlist-top__mobile">
			<a href="javascript:void(0);" class="productlist-top__mobile--view">
				<svg
					class="icon toinline "
					:class="{'active': 'inline' == view}"
					@click.stop.prevent="changeView('card')"
					v-html="getIconHtml('icon-ListLine')"
				></svg>
				<svg
					class="icon togrid "
					:class="{'active': 'card' == view}"
					@click.stop.prevent="changeView('inline')"
					v-html="getIconHtml('icon-ListGrid')"
				></svg>
			</a>
		</div>

		<div class="productlist-top__gridtype">
			<button
				class="productlist-top__gridtype--list"
				:class="{'active': 'inline' == view}"
				@click.stop.prevent="changeView('inline')"
			>
				<svg class="icon" v-html="getIconHtml('icon-ListLine')"></svg>
			</button>
			<button
				class="productlist-top__gridtype--grid "
				:class="{'active': 'inline' != view}"
				@click.stop.prevent="changeView('card')"
			>
				<svg class="icon" v-html="getIconHtml('icon-ListGrid')"></svg>
			</button>
		</div>
	</div>
</template>

<script>
import {Vue} from "ui.vue";
import {store} from "citrus.vuex.store";
import SITE_CONFIG from 'citrus.config';

export default {
	name: 'ProductCardView',
	store: store,
	data: function () {
		return {}
	},
	computed: {
		loc: () => Object.freeze(Vue.getFilteredPhrases("PRODUCT_VIEW_")),
		view: function () {
			return this.$store.getters['settings/viewGrid'];
		}
	},
	created() {
		this.$store.dispatch('settings/load');
	},
	methods: {
		getIconHtml: function(iconId) {
			return '<use x="0" y="0" xlink:href="' + SITE_CONFIG.SVG_PATH + '#' + iconId + '" ></use>';
		},
		changeView: function(view) {
			this.$store.dispatch('settings/setViewGrid', view);

			BX.onCustomEvent('Citrus.Vue.Grid:setViewGrid',[{viewGrid:view}])
		}
	},
};
</script>